import { atom, useAtom } from 'jotai';
import type { DetailedPinWithChecked } from '~/modules/design-board/component/all-pins/AllPins';

interface RenameModalState {
    isOpen: boolean;
    pin: DetailedPinWithChecked | null;
}

const renameModalAtom = atom<RenameModalState>({
    isOpen: false,
    pin: null,
});

export const useRenameModal = () => {
    const [state, setState] = useAtom(renameModalAtom);

    const openModal = (pin: DetailedPinWithChecked) => {
        setState({ isOpen: true, pin });
    };

    const closeModal = () => {
        setState({ isOpen: false, pin: null });
    };

    return {
        ...state,
        openModal,
        closeModal,
    };
};
